<template>
  <div>
    <div v-html="html"></div>
  </div>
</template>

<script>
import { getUrlParams, changeTitleClick } from '@/utils/utils'
import { queryConfig } from '@/api/user'
export default {
  name: 'privacyPolicy',
  data () {
    return {
      params: {},
      html: '',
      title: ''
    }
  },
  async created () {
    await this.getUrlParams()
    await this.queryConfig()
    changeTitleClick(this.title)
    console.log(this.params)
  },
  methods: {
    async queryConfig () {
      const res = await queryConfig(this.params)
      console.log(res)
      this.html = res.result.content
      this.title = res.result.title
    },
    async getUrlParams () {
      const res = getUrlParams()
      this.params = res
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
